import { VIEW_HEARTBEAT_REGISTRY_CONFIG_BY_REGISTRY } from '../../schema/heartbeatRegistryConfig';

export default {
    namespaced: true,
    state: {
        configuration: undefined,
    },
    getters: {
        configuration: (state) => state.configuration,
    },
    mutations: {
        set_configuration: (state, configuration) => {
            state.configuration = configuration;
        },
    },
    actions: {
        get: ({ commit, rootGetters }, payload) => {
            return new Promise((resolve, reject) => {
                rootGetters.apollo.query({
                    query: VIEW_HEARTBEAT_REGISTRY_CONFIG_BY_REGISTRY,
                    variables: {
                        projectId: parseInt(payload.project_id, 10),
                        registryId: parseInt(payload.registry_id, 10),
                    },
                    fetchPolicy: 'no-cache',
                    notifyOnNetworkStatusChange: true,
                })
                    .then(({ data, loading }) => {
                        if (!loading && data !== undefined) {
                            commit('set_configuration', data.heartbeatRegistryConfig);
                            resolve(data.heartbeatRegistryConfig);
                        }
                    })
                    .catch((error) => {
                        console.error('Full ApolloError object:', error);
                        if (error.graphQLErrors && error.graphQLErrors.length) {
                            error.graphQLErrors.forEach((gqlError, i) => {
                                console.error(`GraphQL Error[${i}]:`, gqlError.message, gqlError);
                            });
                        }
                        if (error.networkError) {
                            console.error('Network error status code:', error.networkError.statusCode || error.networkError.status);
                            if (error.networkError.bodyText) {
                                console.error('Network error bodyText:', error.networkError.bodyText);
                            }
                            if (error.networkError.result) {
                                console.error('Network error parsed result:', error.networkError.result);
                            }
                        }
                        reject(error);
                    });
            });
        },
    },
};